import { useSocketStore } from '@/stores/socket-store';
import { cn } from '@/shared/lib/utils';

export function ConnectionBanner() {
  const status = useSocketStore((s) => s.status);

  if (status !== 'reconnecting' && status !== 'failed') return null;

  const isReconnecting = status === 'reconnecting';

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="connection-banner"
      className={cn(
        'fixed bottom-4 left-1/2 z-50 -translate-x-1/2',
        'shadow-card flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium',
        isReconnecting
          ? 'bg-muted text-muted-foreground'
          : 'bg-destructive text-primary-foreground',
      )}
    >
      {isReconnecting ? (
        <>
          <span className="size-2 animate-pulse rounded-full bg-current" aria-hidden="true" />
          Reconnecting…
        </>
      ) : (
        <>
          <span className="size-2 rounded-full bg-current" aria-hidden="true" />
          Connection lost. Please refresh the page.
        </>
      )}
    </div>
  );
}
